import { render, staticRenderFns } from "./Avvenimento.vue?vue&type=template&id=10654674&"
import script from "./Avvenimento.vue?vue&type=script&lang=js&"
export * from "./Avvenimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports